import {
  TypographyComponent,
  TypographySize,
  TypographyVariant,
  TypographyWeight,
} from '@vaad1st/component.atom.typography';
import classnames from 'classnames';
import styles from './heading-component.component.module.less';

interface HeadComponentProps {
  as: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  heading: string;
  align: 'left' | 'center' | 'right';
  size:
    | TypographySize.Xxs
    | TypographySize.Xsm
    | TypographySize.Sml
    | TypographySize.Mdm
    | TypographySize.Lrg
    | TypographySize.Xlg
    | TypographySize.Xxl;
  maxWidth?: number | null;
}

const HeadingComponent = ({
  as = 'h2',
  heading,
  align = 'left',
  size = TypographySize.Lrg,
  maxWidth = null,
}: HeadComponentProps) => {
  const widthStyle = {
    maxWidth: maxWidth ? `${maxWidth}px` : 'auto',
  };

  return (
    <div
      className={classnames(styles['heading-component'], {
        [styles['align_center']]: align === 'center',
        [styles['align_right']]: align === 'right',
      })}
      style={widthStyle}>
      <TypographyComponent
        variant={TypographyVariant.Heading}
        as={as}
        size={size}>
        <span title={heading}>{heading}</span>
      </TypographyComponent>
    </div>
  );
};

export default HeadingComponent;
